import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { Product } from '../interfaces/product';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OffersMetricQueryParamsIface } from '../interfaces/offersMetricQueryParams.iface';

@Injectable()
export class MetricsService {
  private readonly url: string;

  constructor(private http: HttpClient) {
    this.url = `${environment.METRICS_API_URL}`;
  }

  getMetric(eventTypes: string[], tags?: any[]): Observable<Product[]> {
    const filter = { eventType: { $in: eventTypes } };
    if (tags.length) {
      Object.assign(filter, { 'tags.value': { $all: tags } });
    }
    const queryParams = new HttpParams().set('filter', JSON.stringify(filter)).set('intervals', 'year,month');
    return this.http.get<any[]>(this.url, { params: queryParams });
  }

  getProductsMetrics({ tags, limit, type, since, until }: OffersMetricQueryParamsIface): Observable<object[]> {
    let queryParams = new HttpParams();
    if (tags.length) {
      queryParams = queryParams.set('filter', JSON.stringify({ 'tags.value': { $all: tags.map(tag => tag.value) } }));
    }
    if (limit) {
      queryParams = queryParams.set('limit', `${limit}`);
    }
    queryParams = queryParams.set('intervals', 'year,month');

    return this.http.get<any[]>(`${this.url}/products/${type}`, { params: queryParams });
  }

  getOffersMetrics({ tags, limit, type, since, until }: OffersMetricQueryParamsIface): Observable<object[]> {
    let queryParams = new HttpParams();
    if (tags.length) {
      queryParams = queryParams.set('filter', JSON.stringify({ 'tags.value': { $all: tags.map(tag => tag.value) } }));
    }
    if (limit) {
      queryParams = queryParams.set('limit', `${limit}`);
    }
    queryParams = queryParams.set('intervals', 'year,month');

    return this.http.get<any[]>(`${this.url}/offers/${type}`, { params: queryParams });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/metrics.service.ts